'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 12.476 9.99 2.461A1.59 1.59 0 0 1 11.115 2c.427 0 .794.154 1.102.461.307.307.46.683.46 1.127 0 .444-.153.811-.46 1.101l-6.224 6.225h16.444c.426 0 .794.153 1.101.46.307.308.461.675.461 1.102 0 .427-.154.794-.461 1.101a1.503 1.503 0 0 1-1.101.461H5.994l6.224 6.225c.307.307.46.683.46 1.127 0 .444-.153.81-.46 1.1a1.65 1.65 0 0 1-1.102.462c-.427.017-.802-.137-1.127-.461L0 12.476Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
});
var ArrowLeft = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.ArrowLeft = ArrowLeft;